export default __webpack_public_path__ + "static/media/logo.11b9223e.svg";